import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import GSTHSN from './Gsthsn'

const Viewgsthsn = () => {
    return (
        <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
            <Helmet>
				<title>GST-HSN Code - View</title>
			</Helmet>
            <Header />
            <div className="container-fluid maindiv d-flex flex-column" style={{ flexGrow: '1' }}>
                <GSTHSN />
            </div>
        </div>
    );
};

export default Viewgsthsn;
